import { IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { getGroupType } from 'reactApp/modules/userQuotaCleaner/helpers/getGroupType';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';
import { sendDwh } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';

export const sendDeleteConfirmationDialogDwh = ({
    name,
    buttonName,
    action,
    groupId,
}: {
    name: string;
    action: 'show' | 'click' | 'close';
    buttonName?: 'submit' | 'cancel';
    groupId?: UserQuotaGroupId;
}) => {
    const dwhData = {
        name,
        paid_user: IS_PAID_USER,
        platform: getPlatformInfo().join('_'),
        group_id: groupId,
        group_type: getGroupType(groupId),
        button_name: buttonName,
    };
    const optionalButtonField: (keyof typeof dwhData)[] = buttonName ? ['button_name'] : [];
    const dwh_enabled_fields: (keyof typeof dwhData)[][] = [['name', ...optionalButtonField, 'group_id', 'group_type', 'platform']];

    sendDwh({
        eventCategory: 'dialog',
        action,
        dwh_enabled: true,
        dwh_enabled_fields,
        dwhData,
    });
};
